import { Link } from 'react-router-dom';

import { Button } from '@/components/common/Button';

/**
 * Upstream's `FeatureErrorFallback` renders a centred notice when a lazily
 * loaded feature fails to mount. The clone reuses that shape for the nav items
 * whose screens were left out of scope, so the sidebar stays complete instead
 * of silently 404-ing.
 */
export function FeatureUnavailable({ name }: { name: string }) {
  return (
    <div className="flex flex-1 flex-col items-center justify-center gap-3 p-5">
      <p className="text-md font-medium text-error-text">
        「{name}」不在本复刻范围内。
      </p>
      <p className="max-w-md text-center text-sm text-page-text-light">
        这个路由存在，是因为它在 Actual 的侧边栏里；但该界面本身被排除在了本次复刻的范围之外。
      </p>
      <Link to="/budget">
        <Button variant="primary">前往预算页</Button>
      </Link>
    </div>
  );
}
